var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.pots),function(pot,idx){return _c('div',{key:idx,staticClass:"pot"},[_vm._v(" "+_vm._s(_vm.getPot(pot))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }